import { Api } from "./Api.class";
const endpoint = "jobs";
const jobsAPI = new Api(endpoint);
export default jobsAPI;
